#@import Backbone
#@export Booking.Collections.Base

class Booking.Collections.Base extends Backbone.Collection
  constructor: ->
    Backbone.Collection.apply this, arguments
    @_meta = {}
    @on 'request', @loading
    @on 'sync', @loaded
    @on 'error', @loaded

  meta: (prop, value) ->
    @_meta[prop] = value if value isnt undefined
    @_meta[prop]

  loading: ->
    @meta 'loaded', false

  loaded: ->
    @meta 'loaded', true

  isLoading: ->
    @meta('loaded') is false

  isLoaded: ->
    @meta('loaded') is true
